<template>
  <div>
    <div style="font-size: 16px; text-align: center; font-weight: bolder">
      软件许可及服务协议
    </div>
    <br />
    <br />
    <p>{{ span_terms[0] }}</p>
    <p class="clause_span">{{ span_terms[1] }}</p>
    <p class="clause_span">{{ span_terms[2] }}</p>
    <p class="clause_span">{{ span_terms[3] }}</p>
    <p class="clause_span">{{ span_terms[4] }}</p>
    <p>{{ span_terms[5] }}</p>
    <p class="clause_span">{{ span_terms[6] }}</p>
    <p class="clause_span">{{ span_terms[7] }}</p>
    <p>{{ span_terms[8] }}</p>
    <p class="clause_span">{{ span_terms[9] }}</p>
    <p class="clause_span">{{ span_terms[10] }}</p>
    <p>{{ span_terms[11] }}</p>
    <p class="clause_span">
      {{ span_terms[12] }}<br />
      <span> {{ span_terms[13] }} </span><br />
      <span> {{ span_terms[14] }} </span><br />
      <span> {{ span_terms[15] }} </span><br />
      <span> {{ span_terms[16] }} </span><br />
      <span> {{ span_terms[17] }} </span><br />
      <span> {{ span_terms[18] }} </span><br />
      <span> {{ span_terms[19] }} </span><br />
      <span> {{ span_terms[20] }} </span><br />
      <span> {{ span_terms[21] }} </span><br />
    </p>
    <p class="clause_span">
      {{ span_terms[22] }}<br />
      <span> {{ span_terms[23] }} </span><br />
      <span> {{ span_terms[24] }} </span><br />
      <span> {{ span_terms[25] }} </span><br />
    </p>
    <p class="clause_span">{{ span_terms[26] }}</p>
    <p class="clause_span">{{ span_terms[27] }}</p>
    <p class="clause_span">{{ span_terms[28] }}</p>
    <p class="clause_span">{{ span_terms[29] }}</p>
    <p class="clause_span">{{ span_terms[31] }}</p>
    <p class="clause_span">{{ span_terms[32] }}</p>
    <p class="clause_span">{{ span_terms[33] }}</p>
    <p class="clause_span">{{ span_terms[34] }}</p>
    <p class="clause_span">{{ span_terms[35] }}</p>
    <p class="clause_span">{{ span_terms[36] }}</p>
    <p class="clause_span">{{ span_terms[37] }}</p>
    <p class="clause_span">{{ span_terms[38] }}</p>
    <p class="clause_span">{{ span_terms[39] }}</p>
    <p class="clause_span">{{ span_terms[40] }}</p>
    <p class="clause_span">{{ span_terms[41] }}</p>
    <p class="clause_span">{{ span_terms[42] }}</p>
    <p class="clause_span">{{ span_terms[43] }}</p>
    <p class="clause_span">{{ span_terms[44] }}</p>
    <p class="clause_span">{{ span_terms[45] }}</p>
    <p class="clause_span">{{ span_terms[46] }}</p>
    <p class="clause_span">{{ span_terms[47] }}</p>
    <p class="clause_span">{{ span_terms[48] }}</p>
    <p>{{ span_terms[49] }}</p>
    <p>{{ span_terms[50] }}</p>
    <p>{{ span_terms[51] }}</p>
    <p>{{ span_terms[52] }}</p>
    <p class="clause_span">{{ span_terms[53] }}</p>
    <p class="clause_span">{{ span_terms[54] }}</p>
    <p class="clause_span">{{ span_terms[55] }}</p>
    <p class="clause_span">{{ span_terms[56] }}</p>
    <p class="clause_span">{{ span_terms[57] }}</p>
    <p>{{ span_terms[58] }}</p>
    <p class="clause_span">{{ span_terms[59] }}</p>
    <p class="clause_span">{{ span_terms[60] }}</p>
    <p>{{ span_terms[61] }}</p>
    <p class="clause_span">{{ span_terms[62] }}</p>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import { span_terms } from "@/views/components/api/terms";
export default {
  name: "",
  data() {
    return {
      span_terms,
    };
  },
};
</script>

<style lang="less">
.clause_span {
  text-indent: 2em;
}
</style>